module.exports = __webpack_public_path__ + "img/05.98e2cf00.jpg";